import {HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpClient} from '@angular/common/http';
import { Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import {from, Observable, throwError} from 'rxjs';
import {APP_LANGUAGES} from "../constants";
import { AuthService } from "./auth.service";
import { ProfileService } from './profile.service';
import {PublicHttpService} from "./publicHttp.service";
import {catchError, switchMap} from "rxjs/operators";
import {SessionService} from "./session.service";

@Injectable( {
	providedIn: "root"
} )

export class HttpInterceptorService implements HttpInterceptor {
	currentLanguage = APP_LANGUAGES.GERMAN;
	httpClient: HttpClient;
	refreshInProgress: boolean = false;
	waitingResolvers: Function[] = [];

	constructor(
		private authService: AuthService,
		private i18nService: TranslateService,
		private profileService: ProfileService,
		private publicHttpService: PublicHttpService,
		private sessionService: SessionService
	) {
		this.authService = authService;
		this.httpClient = publicHttpService.publicHttpClient;
		this.i18nService = i18nService;
		this.i18nService.onLangChange.subscribe( response => {
			this.currentLanguage = response?.lang;
		} );
	}

	handleRequestError(error: any) {
		if (this.refreshInProgress) {
			// if the refresh is running other requests may fail. omit error reporting for them.
			return throwError(error);
		} else {
			let errorMessage = error.error;
			if (typeof errorMessage !== 'string') {
				errorMessage = error.error.message;
			}
			if (error.status === 403) {
				const errorPayload = {
					error: {
						message: error.message,
						statusCode: error.status,
						error: error.error
					}
				};
				if (typeof error.error !== 'string') {
					errorPayload.error.error = JSON.stringify(error.error);
				}

				if (errorMessage === '__please_provide_valid_token__' || errorMessage === '__token_tampered__') {
					this.profileService.logoutProfileWithoutRequest();
					return null;
				} else if (errorMessage === '__token_expired__') {
					this.profileService.logoutProfileWithoutRequest();
					return null;
				}
			}
			return throwError(error);
		}
	}

	intercept( request: HttpRequest<any>, next: HttpHandler ): Observable<HttpEvent<any>> {
		request = request.clone( {
			withCredentials: true
		});
		let resolver;
		let promise = new Promise<boolean>(resolve => {
			resolver = resolve;
		});

		if (!this.sessionService.tokenAvailable || this.sessionService.remainingRefreshTokenTime < 30) {
			// if there are no tokens or refresh token is expired just handle request
			resolver(true);
		} else if(!this.refreshInProgress && this.sessionService.remainingAccessTokenTime < 70) {
			this.refreshInProgress = true;
			this.authService.refreshToken().subscribe(r => {
				this.refreshInProgress = false;
				this.waitingResolvers.forEach( resolver => {
					resolver(true);
				});
				resolver(true);
			});
		} else if (this.refreshInProgress) {
			this.waitingResolvers.push(resolver);
		} else {
			resolver(true);
		}

		return from(promise).pipe(switchMap(res => {
			return next.handle( request ).pipe(
				catchError((error) => {
					return this.handleRequestError(error);
				})
			);
		}));
	}
}
